module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.eot?4486ac29725c9135ac6313f567906a83";